export default __webpack_public_path__ + "static/media/tavernx2.2b4bca6b.png";